import { render, staticRenderFns } from "./SKDataTableCheckbox.vue?vue&type=template&id=1c5b0097&"
import script from "./SKDataTableCheckbox.vue?vue&type=script&lang=js&"
export * from "./SKDataTableCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports